import { Component } from 'react';

class ErrorBoundary extends Component {
  state = {
    error: null,
  };
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    const { error } = this.state;

    if (error) {
      console.log(error);
      return (
        <p className={'text-center my-6'}>
          Произошла ошибка <a href="/" className="text-primary">На главную</a>
        </p>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
